"use strict";

exports.__esModule = true;
/*eslint-env browser*/

exports.default = {
  pool: {
    size: navigator.hardwareConcurrency || 8
  }
};